import { makeMessages, makeTranslation } from 'utils'

export default makeMessages(
  {
    replacements: 'actions.replacements',
    remove: 'actions.remove',
  },
  makeTranslation('common'),
)
